import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import jwt_decode from 'jwt-decode';
import adminAuthApi from '../api/adminAuthApi';
import '../styles/admin-theme.css';

function adminTokenIsValid(raw) {
  if (raw == null || typeof raw !== 'string' || !raw.trim()) {
    return false;
  }
  try {
    const { exp } = jwt_decode(raw.trim());
    return Boolean(exp && exp * 1000 > Date.now());
  } catch {
    return false;
  }
}

const AdminLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const raw = localStorage.getItem('adminToken');
    if (adminTokenIsValid(raw)) {
      navigate('/admin', { replace: true });
      return;
    }
    if (raw) {
      adminAuthApi.logout();
    }
  }, [navigate]);

  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = event => {
    const { name, value } = event.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setShowError(false);
    const result = await adminAuthApi.login(
      credentials.email,
      credentials.password
    );
    if (result?.success) {
      navigate('/admin');
      return;
    }
    setErrorMessage(result?.errors || 'Login failed');
    setShowError(true);
  };

  const isFormValid =
    Boolean(credentials.email?.trim()) &&
    Boolean(credentials.password?.trim());

  return (
    <div className='admin-theme d-flex align-items-center'>
      <Container>
        <Row className='login-form p-3 overflow-auto admin-auth-card'>
        <Col lg={6} className='pt-5'>
          <img src='/login.jpg' style={{ width: '100%' }} />
        </Col>
        <Col lg={6} className='login-section'>
          <div className='p-5 pt-4'>
            <Form onSubmit={handleSubmit}>
              <div className='mt-2 text-center mb-3'>
                <img
                  src='/zemneo-logo.png'
                  style={{ width: '120px' }}
                  className='mb-2'
                />
                <div className='admin-subtitle'>Platform Admin</div>
                <h3 className='my-2 mt-5 admin-title'>Login</h3>
              </div>
              <Alert variant='danger' show={showError} className='error-alert'>
                {errorMessage}
              </Alert>
              <Form.Group className='mb-3'>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  style={{ height: '36px' }}
                  type='email'
                  name='email'
                  onChange={handleChange}
                  placeholder='Enter email'
                  value={credentials.email}
                  autoComplete='username'
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicPassword'>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  required
                  style={{ height: '36px' }}
                  type='password'
                  name='password'
                  onChange={handleChange}
                  placeholder='Enter password'
                  value={credentials.password}
                  autoComplete='current-password'
                />
              </Form.Group>
              <Button
                variant='primary'
                type='submit'
                className='admin-primary-btn'
                disabled={!isFormValid}
              >
                Login
              </Button>
            </Form>
          </div>
        </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLogin;
